<template>
  <div>
    <!-- COMPONENTE QUE GERA O LOADING EFECT -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- FIM COMPONENTE QUE GERA O LOADING EFECT -->

    <v-col md="12">
      <v-row>
        <v-col cols="6" sm="6" md="4">
          <div class="tpaCombox">
            <v-combobox @change="changeEmolumento()" v-model="emolumentoSelected" label="Selecione o emolumento" item-value="produto" item-text="produto"
              :items="emolumentosFiltered" return-object rounded></v-combobox>
          </div>
         
        </v-col>
        <v-col cols="6" sm="6" md="4" v-if="(emolumentoSelected !== null &&  emolumentoSelected.produto === 'Propina')">
         <div class="tpaCombox">
            <v-combobox v-model="mesSelected" label="Selecione o mês" item-value="id_mes" item-text="descricao"
              :items="mesesAll" return-object rounded></v-combobox>
          </div>
        </v-col>
        <v-col cols="6" sm="6" md="4">
           <v-text-field
              label="Preço unitário"  
              background-color="#ffff99"
              :rules="ruleRequired"
               v-money="money"
              v-model="precoPropina"
            ></v-text-field>
        </v-col>
        <v-col cols="6" sm="6" md="4">
          <div class="tpaCombox">
            <v-combobox v-model="anoSelected" label="Selecione o ano lectivo" item-value="id" item-text="descricao"
              :items="anosAll" return-object rounded></v-combobox>
          </div>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="resetarPagina()"> Cancelar </v-btn>
        <v-btn color="green darken-1" text @click="criarRegistro($event)"> Guardar</v-btn>
      </v-card-actions>
    </v-col>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import Swal from "sweetalert2";
import { VMoney } from "v-money";
import utilitarios from '../../plugins/utilitarios';
const ls = require("local-storage");
export default {
  props: ["estudante"],
  directives: { money: VMoney },
  data: () => ({
    overlay: false,
    mesesAll: [],
    emolumentos:[],
    emolumentosFiltered:[],
    emolumentoSelected: null,
    mesSelected: null,
    anoSelected: null,
    precoPropina:'',
    money: {
        decimal: ",",
        thousands: ".",
        suffix: " Kz",
        precision: 2,
        masked: false,
      },
    anosAll: [
      { id: 2023, descricao: '2023/24' },
      { id: 2024, descricao: '2024/25' }
    ]
  }),

  computed: {
    usuario() {
      return ls.get("nomeUsuario");
    },
  },

  async created() {
    await this.initializeMeses();
    await this.ListarEmolumentos()
  },

  methods: {
    async initializeMeses() {
      try {
        this.overlay = true;
        this.mesesAll = await axios.get("/mesesFindAll").then((res) => res.data);
      } catch (error) {
        Swal.fire("Informação", "Erro ao carregar os meses!", "error");
      } finally {
        this.overlay = false;
      }
    },

    async ListarEmolumentos() {
      try {
        this.emolumentos = await axios
          .get("/produtosFindall-escolas")
          .then((res) => res.data);
        this.emolumentos = this.emolumentos.filter(
          (f) => f.produto !== "Propina"
        );
        this.emolumentosFiltered = this.emolumentos.filter(
          (e) =>
            e.curso_id == this.estudante.idCurso &&
            e.classe_id == this.estudante.anoacademico
        );

        this.emolumentosFiltered.push({produto:'Propina'})
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao carregar os emolumentos",
          "error"
        );
      }
    },

    changeEmolumento(){
      this.mesSelected = null
      this.anoSelected = null
      this.precoPropina = null
    },

    async criarRegistro(event) {
      event.preventDefault();
      this.overlay = true;
      try {
        if ( this.anoSelected && this.precoPropina) {

          let params = {
            periodo: this.estudante.periodo,
            classe: this.estudante.anoacademico,
            curso: this.estudante.idCurso,
            idAnoLectivo: this.anoSelected.id,
            mesId: (this.mesSelected == null)?null:this.mesSelected.id_mes,
            matricula: this.estudante.numero_matricula,
            emolumento: this.emolumentoSelected,
            user: this.usuario,
            preco: utilitarios.MoneyValueToInteger(this.precoPropina)
          };

          let result = await axios.post("/criarRegistroUnico", params).then((res) => res.data);

          if (result.status == 1122) {
            Swal.fire('Info', 'Já existente!', 'warning')
          } else if (result.affectedRows >= 1) {
            Swal.fire('Informação', 'Operação realizada com sucesso', 'success')
            this.resetarPagina()
          }
        } else {
          Swal.fire(
            "Informação",
            "Por favor, preecha os campos corretamente!",
            "info"
          );
        }
      } catch (error) {
        console.log(error);
        
        Swal.fire(
          "Erro",
          "Ocorreu um erro ao realizar a operação!",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    resetarPagina() {
      this.mesSelected = null
      this.anoSelected = null
      this.overlay = false
      this.$emit("fecharComponente", false);
    }
  },
};
</script>

<style scoped>
.input-container {
  margin-top: 20px;
  padding: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
}

.input-container>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.input-saldo {
  border: 1px solid #808080;
  padding: 10px;
  border-radius: 10px;
  display: block;
  width: 90%;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
}

input.input-saldo:focus {
  border-color: #808080;
}

.buttons_saldo_opcoes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.input-button {
  display: block;
  background-color: #008000;
  padding: 10px;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
  transition: all 0.5s;
}

.input-button:hover {
  transition: all 0.5s;
  background-color: #0d530d;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 3px;
}
</style>
